export enum RackCoverPaddingStyle {
  BORDER = "BORDER",
  CENTER = "CENTER",
  FULL = "FULL",
}
